function cssAddFade(elem: HTMLElement, speedInSeconds: number) {
    const opacityRule = "opacity " + speedInSeconds + "s ease-in-out";
    elem.style.transition = opacityRule;
    elem.style.display = "block";
    elem.style.opacity = "0";
}

function cssRemoveFade(elem: HTMLElement) {
    elem.style.display = "none";
    elem.style.transition = "none";
}

function cssFadeIn(elem: HTMLElement) {
    setTimeout(function () {
        elem.style.opacity = "1";
    }, 100);
}

function cssFadeOut(elem: HTMLElement) {
    elem.style.opacity = "0";
}

const animations = {
    cssAddFade: cssAddFade,
    cssRemoveFade: cssRemoveFade,
    cssFadeIn: cssFadeIn,
    cssFadeOut: cssFadeOut
};

export { animations };